<template>
<footer class='z-40 w-full border-grey p-4 bg-gray-200 dark:bg-gray-800 shadow transition-colors duration-500 ease-in-out'>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <p class="text-center md:text-left text-green-700 dark:text-green-400">{{text.leftText}}</p>
        <p class="text-center md:text-right dark:text-gray-400">{{text.rightText}} <fa icon="copyright" /> 2018-{{(new Date()).getFullYear()}}</p>
    </div>
    
</footer>
</template>

<script>
export default {
    name:'Footer',
    computed: {
        text() {
            return this.$store.state.footer
        }
    }
}
</script>

<style>

</style>